import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../services/api';

export const useUploadGalleryPhoto = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post<{ photoUrl: string }>('/sitters/gallery', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      return response.data.photoUrl;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sitterProfile'] });
    },
  });
};
